import { copy } from '../content/copy';
import { LButton } from '../components/LButton';
import { SectionLabel } from '../components/SectionLabel';

const tilts = ['-rotate-[0.8deg]', 'rotate-0', 'rotate-[0.8deg]'];

export function Formats() {
  const { formats } = copy;
  return (
    <section id="formats" className="bg-l-paper px-6 md:px-10 py-20 md:py-28">
      <div className="mx-auto max-w-[1120px]">
        <SectionLabel>РАЗДЕЛ 01 · ФОРМАТЫ</SectionLabel>
        <h2 className="font-display font-medium text-l-ink-deep text-[32px] md:text-[40px] leading-[1.15] tracking-[-0.02em] mb-10">
          {formats.title}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {formats.items.map((item, i) => (
            <div
              key={item.name}
              className={`bg-l-paper-soft rounded-xl p-8 border border-l-rule/60 shadow-ring flex flex-col gap-5 transition-transform duration-200 ease-out ${tilts[i] ?? 'rotate-0'} hover:rotate-0 hover:-translate-y-1 hover:shadow-ring-md hover:border-l-terracotta`}
            >
              <div>
                <h3 className="font-display text-l-ink-deep text-2xl mb-2">{item.name}</h3>
                <p className="font-sans font-semibold text-l-terracotta text-lg">{item.price}</p>
                <p className="font-sans text-l-ink-muted text-sm mt-1">{item.frequency}</p>
              </div>
              <ul className="flex flex-col gap-2 flex-grow">
                {item.bullets.map((b) => (
                  <li key={b} className="font-sans text-l-ink text-[15px] leading-[1.5] pl-4 relative">
                    <span className="absolute left-0 top-[0.7em] w-2 h-px bg-l-marginalia" aria-hidden />
                    {b}
                  </li>
                ))}
              </ul>
              <LButton href="#contact" variant="secondary" className="w-full">
                {item.cta}
              </LButton>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
